import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BriefcaseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BriefcaseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M19.3198 20.5898H4.85986C3.33252 20.5898 2.08984 19.3477 2.08984 17.8203V9.59473C2.08984 8.06739 3.33252 6.82422 4.85986 6.82422H19.3198C20.8472 6.82422 22.0898 8.06738 22.0898 9.59473V17.8203C22.0898 19.3477 20.8472 20.5898 19.3198 20.5898ZM4.85986 7.82423C3.88379 7.82423 3.08984 8.61818 3.08984 9.59474V17.8203C3.08984 18.7959 3.88379 19.5899 4.85986 19.5899H19.3198C20.2959 19.5899 21.0898 18.7959 21.0898 17.8203V9.59474C21.0898 8.61818 20.2959 7.82423 19.3198 7.82423H4.85986Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.5967 20.5898H8.58301C8.30664 20.5898 8.08301 20.3662 8.08301 20.0898V5.04493C8.08301 4.14356 8.81641 3.41016 9.71778 3.41016H14.4614C15.3633 3.41016 16.0967 4.14356 16.0967 5.04493V20.0898C16.0967 20.3662 15.8731 20.5898 15.5967 20.5898ZM9.08301 19.5898H15.0967V5.04493C15.0967 4.69532 14.8115 4.41016 14.4614 4.41016H9.71778C9.36768 4.41016 9.08301 4.69532 9.08301 5.04493V19.5898Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BriefcaseIcon;
